import * as React from 'react'

import { useTranslation } from 'react-i18next'

import { Text } from '@chakra-ui/react'

import { matchesEndpointQuery } from '~/pages/ApiKeys/components/EndpointList'
import { useApiKeyRoles } from '~/pages/ApiKeys/hooks/useApiKeyRoles'

import { RoleCard } from './RoleCard'

type Props = {
  query: string
  selectedRoleNames: string[]
  onToggle: (roleName: string) => void
}

export const RoleCandidates: React.FC<Props> = ({
  query,
  selectedRoleNames,
  onToggle,
}) => {
  const { t } = useTranslation()
  const roles = useApiKeyRoles(query)
  const matchedEndpointCount = roles
    .flatMap((role) => role.endpoints)
    .filter((endpoint) => matchesEndpointQuery(endpoint, query)).length

  return (
    <>
      {query !== '' && (
        <Text textStyle="textSm" color="Text.accentPrimary">
          {t('pages.api_keys.form.roles.filterResult', {
            query,
            endpointCount: matchedEndpointCount,
            roleCount: roles.length,
          })}
        </Text>
      )}
      {roles.length === 0 ? (
        <Text color="Text.lowEmphasis">
          {t('pages.api_keys.form.roles.empty')}
        </Text>
      ) : (
        roles.map((role) => (
          <RoleCard
            key={role.name}
            role={role}
            query={query}
            isSelected={selectedRoleNames.includes(role.name)}
            onToggle={onToggle}
          />
        ))
      )}
    </>
  )
}
